import { DETAILS, COLLATERALDATA, PEOPLESECTIONDATA, RELATEDASSETS, RESET_ADDITIONAL_DETAILS, SET_DETAILPAGE_RESULT } from '../../constants/reducerTypes';

const initialState = {};
const detailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case DETAILS:
      return {
        ...state,
        ...action.payload.entity.dataProvider.detail
      };
    case COLLATERALDATA:
      return {
        ...state,
        collaterals: action.payload
      };
    case RELATEDASSETS:
      return {
        ...state,
        relatedAssets: action.payload
      };
    case PEOPLESECTIONDATA:
      return {
        ...state,
        contacts: action.payload
      };
    case SET_DETAILPAGE_RESULT:
      return {
        ...state,
        details: action.payload
      }
    case RESET_ADDITIONAL_DETAILS:
      return {
        ...state,
        relatedAssets: {},
        collaterals: [],
        contacts: []
      }
    default:
      return state;
  }
};
export default detailsReducer;
